import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { BaseController } from '../../../core/controllers/base.controller';
import { SearchResultModel } from './search-result.model';

@Injectable()
export class SearchAsYouTypeDefaultDataProviderService extends BaseController {

    getIdentifier(): string {
        return 'Default';
    }

    getResults(searchValue: string): Observable<Array<SearchResultModel>> {
        return of([]);
    }

    getResult(id: string): Observable<SearchResultModel> {
        return of({id: undefined, text: '', value: undefined});
    }
}



// WEBPACK FOOTER //
// ./src/app/atoms/search-as-you-type/search-as-you-type-default-data-provider.service.ts